import {
  Box,
  Stack,
} from '@chakra-ui/react';
import { Button } from "@/components/ui/button"
import { useEffect, useRef, useState } from 'react';
import { useAuthContext } from 'src/auth/AuthContext';
import AvatarEditor from 'react-avatar-editor';
import Dropzone from 'react-dropzone';
import { userService } from 'src/service/UserService';
import Content from '@/components/Content';
import SectionPanel from '@/components/SectionPanel';
import WaitingSpinner from '@/components/WaitingSpinner';
import UserProfileSection from '../admin/UserProfileSection';
import { User } from '@/api/User';
import ChangePasswordDialog from './ChangePasswordDialog';
import ContractTabs from '@/components/ContractTabs';
import { ContractSummary } from '@/api/ContractSummary';
import { workmodelService } from '@/service/WorkModelService';
import { OrgUtil } from '@/data/OrgUtil';


const Profile = () => {
  const [isPasswordDialogOpen, setIsPasswordDialogOpen] = useState(false);

  const editor = useRef(null); // avatar editor

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [avatarUrl, setAvatarUrl] = useState<string | File>('');
  const { user, update: updateUser } = useAuthContext();
  const [contract, setContract] = useState<ContractSummary | null>(null);
  const userId = user?.data.id;
  const shouldShowContractTabs = Boolean(user && !OrgUtil.isRoleExtern(user.data.role));

  useEffect(() => {
    setContract(null);
    if (!shouldShowContractTabs || userId == null) return;

    let cancelled = false;
    workmodelService.contractSummary(userId).then(summary => {
      if (!cancelled) setContract(summary);
    });
    return () => { cancelled = true; };
  }, [shouldShowContractTabs, userId]);

  useEffect(() => {
    const url = userService.avatarUrl(user);
    console.log('avatar url = ' + url);
    setAvatarUrl(url);
  }, [user]);

  const handleAvatarSubmit = async event => {
    console.info('changing avatar...');
    event.preventDefault();
    try {
      setIsSubmitting(true);
      editor.current.getImageScaledToCanvas().toBlob((blob) => {
        // upload blob to server
        userService.avatarUpload(blob)
        setIsSubmitting(false);
        console.info('avatar uploaded');
      }, 'image/jpeg');
    } catch (error) {
      console.error(error);
      setIsSubmitting(false);
    }
  };

  const setUserProfile = (data: User) => {
    updateUser(data.firstName, data.lastName);
  }

  return (
    <Content title='Profil'>
      <Stack gap='6' minW='0' w='full' maxW='3xl' mx='auto'>
        {shouldShowContractTabs && (
          <ContractTabs summary={contract} monthMinutes={contract?.workedMinutesThisMonth ?? null} month={new Date()} />
        )}
        <SectionPanel title='Profil' actions={isSubmitting && <WaitingSpinner size='sm' />}>
          <UserProfileSection
            user={user?.data}
            setIsLoading={setIsSubmitting}
            onUserChange={setUserProfile}
          />
        </SectionPanel>
        <SectionPanel title='Sicherheit' actions={isSubmitting && <WaitingSpinner size='sm' />}>
          <Button loading={isSubmitting} colorPalette='blue' variant='outline' onClick={() => setIsPasswordDialogOpen(true)}>
            Passwort ändern
          </Button>
        </SectionPanel>
        <SectionPanel title='Bild ändern ⭐️' actions={isSubmitting && <WaitingSpinner size='sm' />}>
          <Box flex="1" display="flex" justifyContent="center" alignItems="center" background='bg.muted'>
            <Dropzone
              onDrop={(dropped) => {
                setAvatarUrl(dropped[0]);
              }}
              // noClick
              noKeyboard
            >
              {({ getRootProps, getInputProps }) => (
                <div {...getRootProps()}>
                  <AvatarEditor
                    image={avatarUrl}
                    ref={editor}
                    width={150}
                    height={150}
                    border={10}
                    color={[255, 255, 255, 0.6]} // RGBA
                    scale={1.2}
                    rotate={0}
                    borderRadius={100}
                    onLoadFailure={() => {
                      console.log('avatar onLoadFailure');
                      setAvatarUrl('/images/matterhorn-256.webp');
                    }}
                  />
                  <input {...getInputProps()} />
                </div>
              )}
            </Dropzone>
          </Box>
          <Stack gap={2} pt={2} direction={{ base: 'column', sm: 'row' }} justify={'flex-end'} mt='auto'>
            <Button loading={isSubmitting} colorPalette='blue' onClick={event => handleAvatarSubmit(event)}>
              Bild ändern
            </Button>
          </Stack>
        </SectionPanel>
      </Stack>

      <ChangePasswordDialog
        isOpen={isPasswordDialogOpen}
        isSubmitting={isSubmitting}
        setIsSubmitting={setIsSubmitting}
        onClose={() => setIsPasswordDialogOpen(false)}
      />
    </Content>
  );
}

export default Profile
